import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FlagSize } from './flag.constant';

@Component({
  selector: 'cigna-flag',
  templateUrl: './flag.component.html',
  styleUrls: ['./flag.component.scss'],
})
export class FlagComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() flagged = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() disabled = false;
  @Input() size: FlagSize = 'small';
  @Output() change = new EventEmitter();

  addText = 'Flag to add to your Dashboard';
  removeText = 'Unflag to remove from your Dashboard';
}
